import { LOCATION_SHORT_NAME, LONGITUDE_SHORT_NAME, LATITUDE_SHORT_NAME } from '../filters/location/locationFiltersConfig'
import {
  userLocationIpAddressInfo
} from "../mapboxGeocoding.js"
import { MAPBOX_API_KEY } from "../../../constants/index"
var geo = require('mapbox-geocoding')

geo.setAccessToken(MAPBOX_API_KEY)

export const mapboxDiscoverLocationFilters = async ({ values, onSuccess }) => {

  //this function takes in loc, lat, lng values, and tries to determine if they are valid
  //if they are are, we format them some, if not, we return the closest thing we can to an apporximate location of the user.

  let location = values[LOCATION_SHORT_NAME]
  let lng = values[LONGITUDE_SHORT_NAME]
  let lat = values[LATITUDE_SHORT_NAME]

  //we do a quick reset so we can deal only in nulls going forward
  location = location ? location : null
  lat = lat ? lat : null
  lng = lng ? lng : null

  let foundLocation = location
  let foundLatitude = lat
  let foundLongitude = lng

  let locationValues = {}
  locationValues[LOCATION_SHORT_NAME] = foundLocation
  locationValues[LATITUDE_SHORT_NAME] = foundLatitude
  locationValues[LONGITUDE_SHORT_NAME] = foundLongitude

  //if we have info for it all, we just return it back basically
  if (location && lng && lat) {
    locationValues[LOCATION_SHORT_NAME] = location
    locationValues[LONGITUDE_SHORT_NAME] = lng
    locationValues[LATITUDE_SHORT_NAME] = lat
    onSuccess(locationValues)
  }

  //if we have lat and lng but no location we do a reverse look up and return the new location name
  if (!location && lat && lng) {
    let reverseAddress = 'Nowhere'
    // Reverse geocode coordinates to address.
    geo.reverseGeocode('mapbox.places', lat, lng, function (err, geoData) {
      if (geoData?.features?.length > 0) {
        reverseAddress = geoData?.features[0]?.place_name
      } else {
        reverseAddress = 'Nowhere'
      }
    });
    locationValues[LOCATION_SHORT_NAME] = reverseAddress
    locationValues[LONGITUDE_SHORT_NAME] = lng
    locationValues[LATITUDE_SHORT_NAME] = lat
    onSuccess(locationValues)
  }

  //if we have lat and lng but no location we do a reverse look up and return the new location name
  if (location && (!lat || !lng)) {
    let latlng = {}
    //do geocode look up here.
    geo.geocode('mapbox.places', location, function (err, geoData) {
      if (geoData?.features) {
        Object.assign(latlng, { lat: geoData?.features[0]?.center[1], lng: geoData?.features[0]?.center[0] });
      } else {
        Object.assign(latlng, { lat: geoData?.features[0]?.center[1], lng: geoData?.features[0]?.center[0] });
      }
    });
    locationValues[LOCATION_SHORT_NAME] = location
    locationValues[LONGITUDE_SHORT_NAME] = latlng.lng
    locationValues[LATITUDE_SHORT_NAME] = latlng.lat
    onSuccess(locationValues)
  }


  if (!location && !lat && !lng) {
    await userLocationIpAddressInfo()
      .then(
        function (response) {
          //console.log('our response here', response)
          locationValues[LOCATION_SHORT_NAME] = response.location
          locationValues[LONGITUDE_SHORT_NAME] = response.lng
          locationValues[LATITUDE_SHORT_NAME] = response.lat
          onSuccess(locationValues)
          //eslint-disable-next-line
        }.bind(this)
      )
      .catch(
        function (error) {
          locationValues[LOCATION_SHORT_NAME] = location
          locationValues[LONGITUDE_SHORT_NAME] = lng
          locationValues[LATITUDE_SHORT_NAME] = lat
          onSuccess(locationValues)
          //eslint-disable-next-line
        }.bind(this)
      )
  }

  //if we somehow make it all the way down here for some weird bug reason,
  //we just return the original values to avoid an error.
  //let locationValues = {}
  //locationValues[LOCATION_SHORT_NAME] = foundLocation
  //locationValues[LATITUDE_SHORT_NAME] = foundLatitude
  //locationValues[LONGITUDE_SHORT_NAME] = foundLongitude
  //return locationValues*/
}
